// Mulberry Shield

// Clips
export const FETCH_CLIP_ID_REQUEST = 'FETCH_CLIP_ID_REQUEST'
export const FETCH_CLIP_ID_SUCCESS = 'FETCH_CLIP_ID_SUCCESS'
export const FETCH_CLIP_ID_ERROR = 'FETCH_CLIP_ID_ERROR'
export const UPDATE_CLIP_ID_SUCCESS = 'UPDATE_CLIP_ID_SUCCESS'
export const UPDATE_CLIP_ID_ERROR = 'UPDATE_CLIP_ID_ERROR'

export const FETCH_JURISDICTIONS_REQUEST = 'FETCH_JURISDICTIONS_REQUEST'
export const FETCH_JURISDICTIONS_SUCCESS = 'FETCH_JURISDICTIONS_SUCCESS'
export const FETCH_JURISDICTIONS_ERROR = 'FETCH_JURISDICTIONS_ERROR'
